import { Container } from "@mui/system";
import React from "react";

const Dashboard = () => {
	return <Container>Dashboard</Container>;
};

export default Dashboard;
